import { Link } from '@inertiajs/react';

export default function PageHeader({
    title,
    subtitle,
    breadcrumbs = [],
    actions,
    className = '',
}) {
    return (
        <div className={`page-header mb-4 ${className}`}>
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
                <div>
                    {breadcrumbs.length > 0 && (
                        <nav aria-label="breadcrumb" className="mb-1">
                            <ol className="breadcrumb breadcrumb-sm mb-0">
                                <li className="breadcrumb-item">
                                    <Link href="/" className="text-muted">
                                        <i className="bi bi-house-door"></i>
                                    </Link>
                                </li>
                                {breadcrumbs.map((crumb, idx) => (
                                    <li
                                        key={idx}
                                        className={`breadcrumb-item ${idx === breadcrumbs.length - 1 ? 'active text-dark' : ''}`}
                                    >
                                        {crumb.href && idx !== breadcrumbs.length - 1 ? (
                                            <Link href={crumb.href} className="text-muted text-decoration-none">{crumb.label}</Link>
                                        ) : (
                                            <span>{crumb.label}</span>
                                        )}
                                    </li>
                                ))}
                            </ol>
                        </nav>
                    )}
                    <h1 className="h3 fw-bold mb-0">{title}</h1>
                    {subtitle && <p className="text-muted mb-0 mt-1">{subtitle}</p>}
                </div>
                {actions && <div className="page-actions">{actions}</div>}
            </div>
        </div>
    );
}
